export const isFold = state => state.isFold


